import React from "react";
import Fertilizer from "./Fertilizer";

function page(){
    return(

        <>
        <Fertilizer />
        </>

    );
}
export default page;